


















import Vue from "vue";
import EinstellungenAPIKeyComp from "../components/einstellungen/EinstellungenAPIKeyComp.vue";
import EinstellungenEmailComp from "../components/einstellungen/EinstellungenEmailComp.vue";
import EinstellungenPasswordComp from "../components/einstellungen/EinstellungenPasswordComp.vue";
import EinstellungenThemeComp from "../components/einstellungen/EinstellungenThemeComp.vue";

export default Vue.extend({
	name: "EinstellungenPage",
	components: {
		EinstellungenPasswordComp,
		EinstellungenEmailComp,
		EinstellungenAPIKeyComp,
		EinstellungenThemeComp,
	},
});
